module.exports = __webpack_public_path__ + "static/media/clipboard.9f6cc277.svg";